<template>
  <div id="app">
    <component :is="currentView" :currentView.sync="currentView"></component>
  </div>
</template>

<script>
  window.location.href = 'https://palmbeachtan.com/dashboards/bi';
</script>
